import React, { Component } from 'react';
import PropTypes from 'prop-types';
import OptimizeImagesService from 'services/OptimizeImages.service';

import styles from './SmallInfoBox.module.scss';

export default class SmallInfoBoxComponent extends Component {
  static defaultProps = {
    className: ''
  };

  static propTypes = {
    item: PropTypes.object.isRequired
  };

  render() {
    const {
      className,
      item: { header, logo, description }
    } = this.props;

    return (
      <div className={`${styles.SmallInfoBox} ${className}`}>
        <div className={styles.SmallInfoBoxColumn}>
          <div className={styles.SmallInfoBoxLogo}>
            <img src={OptimizeImagesService.adjustImageSize(logo)} alt="logo" />
          </div>
        </div>
        <div className={styles.SmallInfoBoxColumn}>
          <h3>{header}</h3>
        </div>
        <div className={styles.SmallInfoBoxColumn}>
          <p className={styles.SmallInfoBoxDescription}>{description}</p>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/MissionAndVision/components/SmallInfoBox/SmallInfoBox.js